import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.864 3.002a1 1 0 01.817.524c.819 1.524 2.2 2.908 3.696 3.62.24-.987.711-1.87 1.396-2.57C11.757 3.57 13.124 3 14.7 3c1.032 0 1.917.197 2.673.6.581.311 1.05.724 1.434 1.2H21a1 1 0 01.832 1.555l-1.635 2.452c-.057 3.208-1.008 6.047-2.835 8.117C15.464 19.075 12.704 20.3 9.3 20.3c-1.993 0-3.458-.526-4.606-1.338-1.11-.786-1.868-1.805-2.49-2.656a1.001 1.001 0 01.523-1.569l.085-.027.307-.102.868-.29c-2.376-3.308-2.323-7.656 0-10.9a1 1 0 01.877-.416zM5.7 14.8l.318.948-.418.14-.922.309-.025.008a6.5 6.5 0 001.196 1.124c.788.558 1.844.971 3.451.971 2.896 0 5.085-1.025 6.563-2.7 1.488-1.686 2.334-4.127 2.337-7.087a.998.998 0 01.175-.58l.756-1.133H18.3a1 1 0 01-.835-.45c-.294-.446-.626-.767-1.034-.985C16.021 5.147 15.473 5 14.7 5c-1.075 0-1.915.38-2.497.974-.587.6-.968 1.478-1.004 2.56a1 1 0 01-1.235.938c-2.009-.488-3.834-1.898-5.111-3.56-1.185 2.678-.708 5.894 1.558 8.185a1 1 0 01-.393 1.651L5.7 14.8z",
      fill: "#2d6ded"
    }
  )
), a = l;
export {
  a as default
};
